import { render, staticRenderFns } from "./ClientJbbfBasePagination.vue?vue&type=template&id=74df2671&"
import script from "./ClientJbbfBasePagination.vue?vue&type=script&lang=js&"
export * from "./ClientJbbfBasePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports